module.exports = require("./../../_gen/starling/display/Sprite3D");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/display/Sprite3D.js
// module id = 173
// module chunks = 0